import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import { MediaTypes } from "@coworker/app/src/components/RoomSettings/constants";
import { getMediaTypeText } from "@coworker/app/src/components/RoomSettings/tools";
import styles from "./media-name-and-type.module.css";

interface MediaNameAndTypeProps {
  mediaName: string;
  mediaType: string;
}

export const MediaNameAndType = ({
  mediaName,
  mediaType,
}: MediaNameAndTypeProps) => {
  return (
    <div className={styles["media-name-type-container"]}>
      <FixaText textStyle="Body.S">
        {getMediaTypeText(mediaType as MediaTypes)}
      </FixaText>
      <FixaText textStyle="Heading.XS">{mediaName}</FixaText>
    </div>
  );
};
